import DateTimeComponent from './DateTime';
import { forwardRef, useImperativeHandle, useRef, useCallback } from 'react';
import { useGridCellEditor } from 'ag-grid-react';
const DateTimeEditor = forwardRef(({ onValueChange, onChange, value, ...otherProps }, ref) => {
  let dateTimeValueRef = useRef(null);
  const inputRef = useRef();
  const isEditingCompletedRef = useRef(false);
  
  useImperativeHandle(
    ref,
    () => ({
      getValue: () => dateTimeValueRef.current
    }),
    []
  );

  const isCancelAfterEnd = useCallback(() => {
    if (isEditingCompletedRef.current) return true; // Returning true to avoid setting new value
    isEditingCompletedRef.current = true; // prevent further commits
    onValueChange(dateTimeValueRef.current);
    return false;
  }, [onValueChange]);

  const focusInput = () => {
    if (!otherProps.disableFocus && inputRef?.current?.inputElement) {
      inputRef.current.inputElement.focus();
    }
  };

  const afterGuiAttached = useCallback(() => {
    focusInput();
  }, []);

  useGridCellEditor({
    isCancelAfterEnd,
    afterGuiAttached,
    focusInput
  });

  const handleUpdate = useCallback(
    (value) => {
      dateTimeValueRef.current = value;
      onChange?.(value);
    },
    [onChange]
  );

  return (
    <DateTimeComponent
      {...otherProps}
      value={value}
      onChange={handleUpdate}
      inputRef={inputRef}
      focusInput={focusInput}
    />
  );
});
export default DateTimeEditor;
